import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { rowsAnimation, TableElement, TableExportUtil } from '@shared';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Direction } from '@angular/cdk/bidi';
import { RestClientService } from '@core/service/rest-client.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { FeatherIconsComponent } from '@shared/components/feather-icons/feather-icons.component';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { AuthService } from '@core/service/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PrintService } from '@core/service/print.service';
import _ from 'lodash';
import moment from 'moment';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-ged',
  imports: [
    MatButtonModule,
    MatIconModule,
    NgxDatatableModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    CommonModule,
    FeatherIconsComponent,
    MatPaginatorModule,
    IntegerFormatPipe,
    NgbModule,
    NgbDropdownModule,
    BsDatepickerModule,
    NgSelectModule,
  ],
  templateUrl: './ged.component.html',
  styleUrl: './ged.component.scss',
})
export class GedComponent {
  onEditFacture(_t46: any) {
    throw new Error('Method not implemented.');
  }
  expandedRowIndex: number | null = null;
  date_debut: any;
  date_fin: any;
  itemsMenuProgrammeDetail: any = [];
  downloadItems() {
    throw new Error('Method not implemented.');
  }
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  user: any = {};
  itemToSearch: any = {};
  itemsDetailProgramme: any = [];
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number | undefined;
  show_password_field = true;
  loading: boolean = false;
  endPoint: string = 'ged';
  title: string = 'Ged';
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  itemsParentFonctionnalites = [];

  gender = 'M';
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  imageName: string | undefined;
  imageDisplay: any;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();

  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer,
    private printService: PrintService,
    private localeService: BsLocaleService
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('this.user: ', this.user);
    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage =
      'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage =
      'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage =
      'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;

    this.localeService.use('fr');
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.date_debut = firstDay;
    this.date_fin = lastDay;
  }

  pageChanged(event: any): void {
    console.log('event: ', event);
    console.log('event.pageIndex: ', event.pageIndex);
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = '';
  }

  confirmSaveItem(item: any) {
    console.info('item: ', item);

    console.info(' itemToSave ', this.itemToSave);
    console.info(' item ', item);

    if (!item.id && !item.code) item.code = this.generateUniqueString();

    // item.specialiteId = this.selectedSpecialite.id

    if (!item || !item.code) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner code !',
        'bottom',
        'center'
      );
      return;
    }

    // if (!item || !item.codification) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner codification !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    if (!item || !item.libelle) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner libellé !',
        'bottom',
        'center'
      );
      return;
    }
    if (!item || !item.type_affection_id) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner type affection !',
        'bottom',
        'center'
      );
      return;
    }

    if (item.id) delete item.filiale;
    delete item.type_affection;

    let objToSave = Object.assign({}, item);
    if (objToSave.libelle) objToSave.libelle = item.libelle.toUpperCase();

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }
  confirmCancelItem(item: any) {
    let objToSave = Object.assign({}, item);
    objToSave.is_cancel = true;
    objToSave.is_validated = false;
    objToSave.is_traite = true;
    objToSave.date_traitement = new Date();
    objToSave.commentaire_validate = prompt(
      "Veuillez donner la raison de l'annulation: "
    );
    if (!objToSave.commentaire_validate) return;
    Swal.fire({
      title: this.capitalize(this.title),
      text: 'Annulation',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }
  confirmValidate(item: any) {
    let objToSave = Object.assign({}, item);
    objToSave.is_cancel = false;
    objToSave.is_validated = true;
    objToSave.is_traite = true;
    objToSave.date_traitement = new Date();
    Swal.fire({
      title: this.capitalize(this.title),
      text: 'Validation',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }

  saveItem(item: any) {
    console.info('item to save', item);
    this.loading = true;
    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    var request = {
      user_id: this.user.id,
      datas: [itemAEnregistrer],
    };
    this.restClient
      .post(
        this.endPoint + '' + (itemAEnregistrer.id ? '/update' : '/create'),
        request
      )
      .subscribe(
        (res: any) => {
          console.info('resul', res);
          this.loading = false;

          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            this.currentPage = 0;
            this.getItems();
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification(
                'snackbar-danger',
                this.utilities.formatMsgServeur(res['status']['message']),
                'bottom',
                'center'
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center'
          );
          this.loading = false;
        }
      );
  }

  getItems() {
    let request = {
      user_id: this.user.id,
      search_key: this.searchKey,
      data: {},
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.restClient.post(this.endPoint + '/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.items = res['items'];

          this.totalItems = res['count'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.items = [];
          this.totalItems = 0;
        }
      },
      (err) => {}
    );
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('filiale/getByCriteria', request).subscribe(
      (res: any) => {
        console.info('itemsFiliale', res);

        if (res && res['items']) {
          this.itemsFiliale = _.orderBy(res['items'], ['libelle'], ['asc']);
        } else {
          this.itemsFiliale = [];
        }
      },
      (err) => {}
    );
  }

  confirmDelete(item: any) {
    Swal.fire({
      title: this.capitalize(this.title),
      text: this.deleteMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3f51b5',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  }

  deleteItem(obj: any) {
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [obj],
    };

    this.restClient.post(this.endPoint + '/delete', request).subscribe(
      (res: any) => {
        console.info(res);
        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );

          this.currentPage = 0;
          this.getItems();
        } else {
          if (res['status'] && res['status']['message']) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        }
      },
      (err) => {
        console.info('Error occured', err);
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
      }
    );
  }

  onSelectDate(event: any) {
    if (event) {
      ((this.dateNais = moment(event).format('DD/MM/YYYY')),
        console.info('dateNais', this.dateNais));
    }
  }

  changePaginationSize($event: any) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  isValidEmail(email: any) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  onFileChange(ev: any): void {
    const reader = new FileReader();
    const file = ev.target.files[0];

    reader.onload = () => {
      const data = reader.result;
      if (!data) return;

      // Read workbook
      const workBook: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });

      // Convert sheets to JSON
      const jsonData: { [key: string]: any[] } = workBook.SheetNames.reduce(
        (acc: { [key: string]: any[] }, name: string) => {
          const sheet = workBook.Sheets[name];
          acc[name] = XLSX.utils.sheet_to_json(sheet);
          return acc;
        },
        {}
      );

      // Example: extract "Sheet1"
      const itemsToSave = jsonData[workBook.SheetNames[0]] || [];
      console.log('Extracted rows:', itemsToSave);

      if (itemsToSave.length) {
        itemsToSave.map((it: any) => (it.code = this.generateUniqueString()));

        Swal.fire({
          title: 'Importation de données',
          text: 'Voulez-vous importer ces ' + itemsToSave.length + ' élements?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0665aa',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
        }).then((result) => {
          if (result.value) {
            this.uploadData(itemsToSave);
          }
        });
      }
    };

    reader.readAsBinaryString(file);
  }

  uploadData(items: any) {
    this.loading = true;

    var request = {
      datas: items,
    };

    this.restClient.post(this.endPoint + '/create', request).subscribe(
      (res: any) => {
        console.info('resul', res);
        this.loading = false;

        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.currentPage = 0;
          this.getItems();
        } else {
          if (res['status'] && res['status']['message']) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        }
      },
      (err) => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        this.loading = false;
      }
    );
  }

  massiveSaveItem(items: any) {
    // console.info("item to save", item);

    this.loading = true;

    // let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    // itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id
    if (items && items.length) {
      items.map((it: any) => {
        it.code = this.generateUniqueString();
        it.filiale_id = this.filiale_id || this.user.filiale_id;
      });
    }
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: items,
    };

    this.restClient.post('affection/create', request).subscribe(
      (res: any) => {
        console.info('resul', res);
        this.loading = false;

        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );

          this.getItems();
        } else {
          if (res['status'] && res['status']['message']) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        }
      },
      (err) => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        this.loading = false;
      }
    );
  }

  toggleSubtable(item: any, index: number) {
    this.itemsMenuProgrammeDetail = [];
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null; // hide
    } else {
      this.expandedRowIndex = index; // show
      this.getItemsProgrammeDetail(item.id);
    }
  }

  getItemsProgrammeDetail(id: any) {
    let request = {
      data: {
        commande_id: id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('commandeDetail/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsMenuProgrammeDetail = res['items'];

          this.itemsMenuProgrammeDetail.map(
            (impdt: any) => (impdt.menu_prix = impdt.prix)
          );
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsMenuProgrammeDetail = [];
        }
      },
      (err) => {
        this.itemsMenuProgrammeDetail = [];
      }
    );
  }

  openPdf(url: string) {
    this.printService.previewPdf(url);
  }

  ngOnInit() {
    this.getItems();
  }
}
